import { DevTool } from "@hookform/devtools";
import {
  ModalContainer,
  SectionHeader,
  SwitchAppButton,
} from "../../../components";
import { SubmitButton, TextArea, TextInput } from "../../../hook-form";
import { IBankAccountTagFormViewProps } from "./BankAccountTagForm";

export const View = ({
  // isModalOpen,
  closeModal,
  formValues,
  control,
  errors,
  handleSubmit,
  register,
}: IBankAccountTagFormViewProps) => {
  return (
    <ModalContainer
      isModalOpen={true /*isModalOpen*/}
      closeModal={closeModal}
      modalHeader={
        <SectionHeader
          title="Add Bank AccountTag"
          subtitle="Add a new tag that can be used to split payouts into this bank account."
        />
      }
    >
      <form onSubmit={handleSubmit}>
        <div className="flex-container col">
          <TextInput
            name="tag_name"
            label="Tag Name"
            infoIconText="Tag name shown for this account number eg School Uniform Acct, Shop Sales Acct, etc."
            type="text"
            register={register}
            errors={errors}
          />

          <TextArea
            name="description"
            label="Tag Description (Optional)"
            infoIconText="More info about this tag."
            register={register}
            errors={errors}
          />
        </div>

        <div className="flex-container justify-content--end mt-5">
          <div
            id="md_alignment_helper"
            className="flex-box flex-1_5 d-none d-md-flex"
          />
          <div className="flex-box flex-container">
            <SwitchAppButton kind="secondary" onClick={closeModal} size="sm">
              Cancel
            </SwitchAppButton>

            <SubmitButton size="sm" className="ml-5">
              Save
            </SubmitButton>
          </div>
        </div>
      </form>
      <DevTool control={control} /> {/* set up the dev tool */}
    </ModalContainer>
  );
};
